<sl-form [model]="setupEntity" [fields]="fields" [form]="form" [options]="options" (submitted)="onSetupSubmit($event)" [editOnly]="true"
	flyoutTitle="P-Card Import Setup"></sl-form>